import Update from "../table/Update"
import { useState,useEffect } from "react"
import { useParams } from "react-router-dom"
import { useNavigate } from "react-router-dom"
import ApiService from "../../services/apiService"
import { toast } from "react-toastify"
const UpdateOms = () =>{
   const {id} =  useParams();
   const [data,setData] = useState<any>();

     const initialData = {
        ChackName:data.chackName,
        OnOfValves:data.onOfValves,
        DistrubutaryZone:data.distributaryZone,
        schemeVillage:data.schemeVillage,
        Duty:data.duty,
        UpdateTime:data.updateTime,
        Pressure:data.pressure,
        FlowRate:data.flowRate,
        TodayVloume:data.todayVolume,
        OnValves:data.onValves,
        Door1:data.door1,
        Door2:data.door2,
        NetworkStatus:data.networkStatus,
        Battery:data.battery,
        SolarVoltage:data.solarVoltage,
        Temprature:data.temprature,
        WaterMeter:data.waterMeter,
        RomsAuto:data.romsAuto,

     }
     useEffect(()=>{
          const getInitialOms = async() =>{
             try{
                 const response = await ApiService.axiosApi(`/oms/getbyid${id}`,{
                    method:'GET'
                 })
                 if(response.success){
                     setData(response.data)
                 }else{
                    console.log(response.message||response.status||"unable to get initial oms")
                 }
             }catch(error){
                console.log(error)
             }
          }
     },[])

     const onSubmit = async(data:any) =>{
          
        try{
            const response = await ApiService.axiosApi(`/oms/updateoms${id}`,{
                method:'PUT',
                data:data
            })
            if(response.success){
               toast.success("Oms List Updated Successfully")
            }else{
                console.log(response.message||response.status|| "unable to update ")
            }
        }catch(error){
            console.log(error)
        }
     }

    return(
        <>
        <Update
         title = { "Update Oms"}
         parentTitle={"Oms"}
         
         fields ={
          [
            {
               name : "ChackName",
               label : "Chack Name",
               type : "text"
            },
            {
              name : "OnOfValves",
              label : "No Of On/Of Valves",
              type : "text"
            },
             {
                name : "DistrubutaryZone",
                label : "Distributary/Zone",
                type : "text"
             },
             {
                name : "schemeVillage",
                label : "Svheme/Village",
                type : "text"
             },
             {
                name : "Duty",
                label : "Duty",
                type : "text"
             },
             {
                name : "UpdateTime",
                label : "Updated Time",
                type : "text"
             },
             {
                name : "Pressure",
                label : "pressure",
                type : "text"
             },
             {
                name : "FlowRate",
                label : "Flow Rate",
                type : "text"
             },
             {
                name : "TodayVloume",
                label : "Today Volume",
                type : "text"
             },
             {
                name : "OnValves",
                label : "No Of On Vlaves",
                type : "text"
             },
             {
                name : "Door1",
                label : "Door1",
                type : "text"
             },
             {
                name : "Door2",
                label : "Door2",
                type : "text"
             },
             {
                name : "NetworkStatus",
                label : "Network Status",
                type : "text"
             },
             {
                name : "Battery",
                label : " Battery Status",
                type : "text"
             },
             {
                name:"SolarVoltage",
                label:"Solar Voltage",
                type:"text",
             },
             {
                name:"Temprature",
                label:"temprature",
                type:"",
             },
             {
                name:"WaterMeter",
                label:"Water Meter",
                type:"text",
             },
             {
                name:"RomsAuto",
                label:"Roms Auto",
                type:"text",
             }

            ]}

        

         
         onSubmit = {onSubmit}
         initialData = {initialData}
         />
  
         
      </>
    )
}
export default UpdateOms;